import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { useInfiniteBrandKitMediaFiles } from 'hooks/queries/brandKits/useInfiniteBrandKitMediaFiles'
import { getMediaFiles } from 'components/Design/UploadsTab/getMediaFiles'
import { collectResults } from 'utils/query'
import { AlmanacFile } from 'types'
import { useUploads } from 'components/Design/UploadsTab/useUploads'

interface MediaFilesProps {
  children: (props: { mediaFiles: IMediaFile[]; hasNextPage?: boolean; fetchNextPage: () => void }) => JSX.Element
  brandKitId?: number
}

const BrandKitMediaFiles = ({ children, brandKitId }: MediaFilesProps & { brandKitId: number }) => {
  const { accept } = useImagePickerContext()

  const mediaFilesQuery = useInfiniteBrandKitMediaFiles(
    { brandKitId },
    {
      cacheTime: 1000 * 60 * 5,
    },
  )
  const mediaFiles = getMediaFiles(collectResults(mediaFilesQuery, (data) => data.media_files) as AlmanacFile[], accept)
  const { hasNextPage, fetchNextPage } = mediaFilesQuery

  return children({ mediaFiles, hasNextPage, fetchNextPage })
}

const UploadedMediaFiles = ({ children }: MediaFilesProps) => {
  const { accept } = useImagePickerContext()

  const uploadsQuery = useUploads()
  const uploads = collectResults(uploadsQuery, (data) => data.files)
  const mediaFiles = getMediaFiles(uploads, accept)
  const { hasNextPage, fetchNextPage } = uploadsQuery

  return children({ mediaFiles, hasNextPage, fetchNextPage })
}

export const MediaFiles = ({ children, brandKitId }: MediaFilesProps) => {
  if (brandKitId) {
    return <BrandKitMediaFiles brandKitId={brandKitId}>{children}</BrandKitMediaFiles>
  }

  return <UploadedMediaFiles>{children}</UploadedMediaFiles>
}
